import { useEffect, useMemo, useRef } from 'react';
import type { ForgePageName, Extension } from '@helpcenter/forge-ui-utils';
import { BLOCKED } from '@helpcenter/forge-ui-utils';

const useShowBannerHook = (
	// TODO: Fix the issue with the extensions being undefined https://hello.jira.atlassian.cloud/browse/PORTAL-5931
	extensions: Extension[] = [],
	page: ForgePageName,
	shouldCallBanner: boolean,
	showBanner?: (forgePageName: ForgePageName) => void,
	resetBannerState?: (forgePageName: ForgePageName) => void,
): Extension[] => {
	const wasShowBannerCalled = useRef<boolean>(false);
	const allowedExtensions: Extension[] = useMemo(() => {
		if (!extensions?.length) {
			return [];
		}
		return extensions.filter((extension) => {
			return extension?.dataClassificationPolicyDecision?.status !== BLOCKED;
		});
	}, [extensions]);

	useEffect(() => {
		if (shouldCallBanner && allowedExtensions?.length !== extensions?.length && showBanner) {
			showBanner(page);
			wasShowBannerCalled.current = true;
		}

		// oxlint-disable-next-line react-hooks/exhaustive-deps
	}, [allowedExtensions]);

	useEffect(() => {
		return () => {
			if (wasShowBannerCalled.current && resetBannerState) {
				resetBannerState(page);
			}
		};
		// Not adding all deps here since we only want to run this cleanup upon unmount and also when allowedExtensions change
		// oxlint-disable-next-line react-hooks/exhaustive-deps
	}, [allowedExtensions]);

	return allowedExtensions;
};

export default useShowBannerHook;
